import TeamManagement from '../master-management/TeamManagement';

export default function Teams() {
  return (
    <div className="p-4 lg:p-8 max-w-[1920px] mx-auto space-y-6 min-h-screen">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">Teams</h1>
        <p className="text-slate-600 dark:text-slate-400">Manage organizational teams and team structures.</p>
      </div>
      <TeamManagement />
    </div>
  );
}
